import { compose, withProps } from 'recompose'
import { InputText } from './index'
import toReduxFormField from '../../../enhancers/ToReduxFormField'

export const formatSlug = (value = '') => {
  // function ensures that only URL characters that are lowercase and URL safe
  // per RFC 3986: https://www.ietf.org/rfc/rfc3986.txt 2.3. Unreserved characters
  return value.replace(/[^\d\w-_]/g, '')
}

const enhance = compose(
  withProps({
    format: formatSlug,
  }),
  toReduxFormField('InputSlug'),
)

export default enhance(InputText)
